import React from 'react';
import PropTypes from 'prop-types';
import Video from '@mapbox/dr-ui/video';
import Phone from '@mapbox/dr-ui/phone';
import AppropriateImage from './appropriate-image';

class IphoneFrame extends React.PureComponent {
  render() {
    return (
      <div className="mt24 mb36">
        <Phone platform="ios" mode={this.props.rotation}>
          {this.props.imageId ? (
            <AppropriateImage
              imageId={this.props.imageId}
              alt={this.props.alt}
            />
          ) : (
            <Video src={this.props.src} title={this.props.title} />
          )}
        </Phone>
      </div>
    );
  }
}

IphoneFrame.propTypes = {
  src: (props, componentName) => {
    if (!props.src && !props.imageId) {
      return new Error(
        `One of props 'src' (for videos) or 'imageId' (for images) was not specified in '${componentName}'.`
      );
    }
  },
  title: (props, componentName) => {
    if (props.src && !props.title) {
      return new Error(
        `The prop 'title' is required when specifying a 'src' in '${componentName}'.`
      );
    }
    if (props.src && typeof props.title !== 'string')
      return new Error(`Prop 'title' must be a string.`);
  },
  imageId: (props, componentName) => {
    if (!props.src && !props.imageId) {
      return new Error(
        `One of props 'src' (for videos) or 'imageId' (for images) was not specified in '${componentName}'.`
      );
    }
  },
  alt: (props, componentName) => {
    if (props.imageId && !props.alt) {
      return new Error(
        `The prop 'alt' is required when specifying an 'imageId' in '${componentName}'.`
      );
    }
    if (props.imageId && typeof props.alt !== 'string')
      return new Error(`Prop 'alt' must be a string.`);
  },
  rotation: PropTypes.oneOf(['portrait', 'landscape']).isRequired
};

export default IphoneFrame;
